// No-op stub for dtrace-provider — a Node-only package that uses dynamic
// require() for native bindings and is unusable in the browser. It leaks
// transitively into the bundle (likely through a logger). The DTrace provider
// API is server-side telemetry; in the browser it can be a no-op.
//
// ESM exports (Vite serves this directly to the browser; CommonJS module.exports
// would fail with "module is not defined").

function noop() {}

function createDTraceProvider() {
  return {
    addProbe: () => ({ fire: noop }),
    enable: noop,
    disable: noop,
    fire: noop,
    removeProbe: noop,
  };
}

const DTraceProvider = createDTraceProvider;

export { createDTraceProvider, DTraceProvider };
export default createDTraceProvider;
